import styled from 'styled-components';

import { GenericP } from 'common/Styles';
export const DestinationSelect = styled.div`
    display: flex;
    align-items: center;
    margin-top: 24px;
`;

export const Title = styled(GenericP)`
	height: 100%;
`;

export const ListItem = styled.ul(
	({ theme: { down, breakpoints } }) => `
		display: flex;
		flex-direction: row;
		border-left: 2px solid #EAEAEA;
		flex-wrap : wrap;
		${down(breakpoints.md)} {
			flex-wrap : nowrap;
			border-left: none; 
			overflow: scroll;
			::-webkit-scrollbar {
				width: 0; 
				background: transparent;  
			}
			scrollbar-width: none;
			-ms-overflow-style: none; 
		
		}
    `
);

export const Item = styled.li`
	margin-left: 8px;
	margin-top: 5px;
	padding: 11px 15px;
	border-radius: 4px;
	font-size: 14px;
	color: #4A4A4A;
	line-height: 18px;
	border: 1px solid #D7D7D7;
	cursor: pointer;
	flex-shrink: 0;
	&.active {
		background-color: #FF664B;
		color: #fff;
		font-weight: 700;
	}
`;
